export default "__VITE_ASSET__08f3f1c0__"